import React from "react";

/**
 * Composant React pour afficher un message lorsqu'aucun résultat n'est trouvé
 * @param {{title: string, message?: string}} props - Propriétés du composant
 * @returns {any} - Composant React
 */
function CfcNoResult({ title, message }) {
  return (
    <div className="background--dark-grey padding--32 flexline flexline--no-mobile flexline--direction-column flexline--gap-16 flexline--align-hz flexline--align-vz" style={{ borderRadius: "8px" }}>
      <div className="icon icon--circle icon--grey-800" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
        <span className="icon__icon material-icons" aria-hidden="true">
          search_off
        </span>
      </div>
      <p className="paragraph paragraph--center paragraph--grey-0 paragraph--no-margin paragraph--bold-700 paragraph--h5">{title}</p>
      {message ? <p className="paragraph paragraph--center paragraph--grey-100 paragraph--no-margin">{message}</p> : null}
    </div>
  );
}

export default CfcNoResult;
